// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__ddq0B","loader":"loader_loader__AJAll","Table":"loader_Table__0y8l-"};